import { QueryFunction } from '@tanstack/react-query'
import { api } from 'api'
import { Dataset, Folder, Query } from './types'

export async function getTemplates(): Promise<Dataset[]> {
  try {
    const { data } = await api.get('/api/core/v1/templates')
    return data
  } catch {
    return []
  }
}

export async function getFolders(): Promise<Folder[]> {
  try {
    const { data } = await api.get('/api/v1/account/folder')
    return data
  } catch {
    return []
  }
}

export async function addToFavorites(datasetId: number): Promise<void> {
  await api.post(`/api/core/v1/templates/favorite/${datasetId}`)
}

export async function removeFromFavorites(datasetId: number): Promise<void> {
  await api.delete(`/api/core/v1/templates/favorite/${datasetId}`)
}

export const getTemplatesQuery: { queryKey: [Query]; queryFn: QueryFunction<Dataset[], [Query]> } =
  {
    queryKey: [Query.TEMPLATES],
    queryFn: getTemplates,
  }

export const getFoldersQuery: { queryKey: [Query]; queryFn: QueryFunction<Folder[], [Query]> } = {
  queryKey: [Query.FOLDERS],
  queryFn: getFolders,
}

export interface IDatasetImportDto {
  datasetId: number
  datasetUuid: string
  templateId: number
  commitRef?: string
  submissionName: string | null
  headers: any[]
  rows: any[]
}

export async function saveToPendingRollup(
  datasetId: number,
  payload: IDatasetImportDto,
): Promise<any> {
  try {
    const result = await api.post(
      `/api/v1/account/dataset/pending-rollup/save/${datasetId}`,
      payload,
    )
    return result
  } catch (err) {
    console.error('Failed API POST in saveToPendingRollup', err)
    return []
  }
}
